import { render, staticRenderFns } from "./CreateNewMockup.vue?vue&type=template&id=47fe25eb&scoped=true"
import script from "./CreateNewMockup.vue?vue&type=script&lang=js"
export * from "./CreateNewMockup.vue?vue&type=script&lang=js"
import style0 from "./CreateNewMockup.vue?vue&type=style&index=0&id=47fe25eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe25eb",
  null
  
)

export default component.exports